// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3VhPM","errors":"Errors_errors__aIJ8q"};